// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3KNOV","text":"SelectPayment_text__aQwZ4","title":"SelectPayment_title__2o96N","btn":"SelectPayment_btn__oMSqz"};